import { createFileRoute } from "@tanstack/react-router";
import { deviceSessionsQuery } from "@/api/queries/session";
import { AccountSettingsPage } from "@/pages/settings/AccountSettingsPage";

export const Route = createFileRoute("/_app/_authed/settings/account")({
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(deviceSessionsQuery());
  },
  component: AccountSettingsPage,
});
